import React, { Component } from 'react';

import './DefaultPage.scss';
// FUDR-D2: removed dead imports below — <Animatable> usage was commented out,
// but the synchronous import chain (Default → Animatable → react-lottie) was
// pulling ~70 KB of react-lottie into the main bundle on every cold start.
// To re-enable the loader animation, wrap Animatable in asyncRoute and
// re-add the import only when the component is actually rendered.
//
// import * as FudrLoadingAnimationData from '../../assets/animations/fudr-loader-light-bg.json';
// import Animatable from '../../components/elements/Animatable';

class DefaultPage extends Component {
  render() {
    return (
      <div className="default-page">
        <div className="fudr-loading-animation">
          {/* <Animatable animationData={FudrLoadingAnimationData} /> */}
        </div>
      </div>
    );
  }
}

export default DefaultPage;
